"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
const testimonials = [{
  id: 1,
  quote: "THE NEURO-SENSORY TRAINING WAS THE MISSING PIECE. I'M MOVING FASTER AND WITH ZERO PAIN FOR THE FIRST TIME IN YEARS.",
  name: "MARCUS REED",
  major: "ELITE TRIATHLETE",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689046/img/athlete_marcus_bw.png"
}, {
  id: 2,
  quote: "TULSA PAIN & PERFORMANCE DIDN'T JUST TREAT MY SYMPTOMS; THEY REWIRED HOW MY BRAIN PROCESSES MOVEMENT.",
  name: "ELENA VANCE",
  major: "D1 TRACK & FIELD",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689046/img/athlete_elena_bw.png"
}, {
  id: 3,
  quote: "THE PRECISION OF THEIR ASSESSMENT IS UNMATCHED. I GAINED MORE MOBILITY IN THREE SESSIONS THAN IN MONTHS OF TRADITIONAL PT.",
  name: "JASON CHANDLER",
  major: "PRO CROSSFIT",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689046/img/athlete_jason_bw.png"
}];
export default function AthleteSuccessStories() {
  return <section data-section-id="234219" id="athlete-success-stories" className="bg-background text-foreground py-24 sm:py-32 overflow-hidden relative border-t border-border/10">
      {}
      <div className="absolute inset-0 pointer-events-none flex justify-center items-center opacity-10">
        <div className="w-[800px] h-[400px] bg-primary/20 blur-[120px] rounded-md" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i}>
                <div className="flex flex-col items-center justify-center p-4 sm:p-8">
                  <blockquote className="text-2xl md:text-4xl font-default font-bold text-center leading-tight text-foreground mb-10 max-w-4xl mx-auto tracking-tight uppercase italic">
                    "{testimonial.quote}"
                  </blockquote>
                  
                  <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
                    <div className="flex items-center gap-3">
                      <SafeHydrate><Avatar className="size-12 border-2 border-primary shadow-md rounded-md">
                        <AvatarImage src={testimonial.avatarUrl} alt={testimonial.name} className="grayscale contrast-125" />
                        <AvatarFallback className="bg-secondary text-secondary-foreground font-default font-bold">
                          {testimonial.name.split(" ").map(n => n[0]).join("")}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="flex flex-col items-start">
                        <span className="font-default font-bold text-foreground text-sm tracking-wider uppercase">
                          {testimonial.name}
                        </span>
                      </div>
                    </div>
                    
                    <div className="hidden sm:block w-px h-8 bg-primary/30" />
                    
                    <Badge variant="secondary" className="rounded-md px-3 py-1 text-xs font-default font-bold uppercase tracking-widest bg-primary text-primary-foreground shadow-sm">
                      {testimonial.major}
                    </Badge>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="flex items-center justify-center gap-3 mt-12">
            <CarouselPrevious className="static translate-y-0 translate-x-0 bg-background hover:bg-primary hover:text-primary-foreground border-2 border-foreground font-default font-bold text-[10px] tracking-widest uppercase rounded-md shadow-md size-auto px-4 py-2">
              PREV
            </CarouselPrevious>
            <CarouselNext className="static translate-y-0 translate-x-0 bg-background hover:bg-primary hover:text-primary-foreground border-2 border-foreground font-default font-bold text-[10px] tracking-widest uppercase rounded-md shadow-md size-auto px-4 py-2">
              NEXT
            </CarouselNext>
          </div>
        </Carousel>
      </div>
    </section>;
}